import {
  MESSAGE_TAG_FILTER_TYPES,
  SENTIMENT_FILTER_OPTIONS,
} from '@/app/community/constants/communityFilters';

export function getTagOperatorAndValues(param, makeValuesArray = false) {
  const result = {
    values: param,
    operator: MESSAGE_TAG_FILTER_TYPES.OR,
  };
  if (param.includes(':')) {
    const [tagOperator, tagIds] = param.split(':');
    result.operator = tagOperator;
    result.values = makeValuesArray ? tagIds?.split(',').map((t) => Number(t)) : tagIds;
  }

  return result;
}

export function getBooleansFromSentimentsQueryParam(sentiments) {
  return Object.fromEntries(
    [
      ['isPositive', SENTIMENT_FILTER_OPTIONS.POSITIVE.value],
      ['isNegative', SENTIMENT_FILTER_OPTIONS.NEGATIVE.value],
      ['isNeutral', SENTIMENT_FILTER_OPTIONS.NEUTRAL.value],
    ]
      .filter(([, sentimentVal]) => sentiments?.includes(sentimentVal))
      .map(([key]) => [key, true]),
  );
}
